module.exports = __webpack_public_path__ + "img/UG.e0e20932.png";